import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FournisseurDTO } from '../../customs/_models/FournisseurDTO';

@Injectable({
  providedIn: 'root'
})
export class FournisseurService {

  private apiUrl = environment.base_url + '/api/fournisseur';

  constructor(private http: HttpClient) {}

  // 🔹 Créer un nouveau fournisseur
  createFournisseur(fournisseur: FournisseurDTO): Observable<FournisseurDTO> {
    return this.http.post<FournisseurDTO>(this.apiUrl, fournisseur, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  // 🔹 Modifier un fournisseur existant
  updateFournisseur(id: number, fournisseur: FournisseurDTO): Observable<FournisseurDTO> {
    return this.http.put<FournisseurDTO>(`${this.apiUrl}/${id}`, fournisseur, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  // 🔹 Récupérer tous les fournisseurs (avec flag = true côté backend)
  getAllFournisseurs(): Observable<FournisseurDTO[]> {
    return this.http.get<FournisseurDTO[]>(this.apiUrl);
  }

  // 🔹 Récupérer un fournisseur par son ID
  getFournisseurById(id: number): Observable<FournisseurDTO> {
    return this.http.get<FournisseurDTO>(`${this.apiUrl}/${id}`);
  }

  // 🔹 Suppression logique (soft delete)
  deleteFournisseur(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
